/** Frontmatter for the "preseason-week-3-recap" article; the Body lives in preseason-week-3-recap.jsx. */
const meta = {
  slug: 'preseason-week-3-recap',
  title: 'NFL Preseason Week 3 Recap: Cutdown Fallout and Final Draft Moves',
  category: 'Recap',
  author: 'Andy Darkness',
  excerpt:
    'The preseason finale from all 16 games, read the way a starters-rested week has to be read: which depth roles firmed up, which auditions were for other teams, and which injuries and cutdown-day moves actually change a draft board.',
  readMinutes: 21,
  date: '2026-09-01',
};

export default meta;
